
import { Component, Vue } from 'vue-property-decorator';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';
import DepositsTable from '@/components/common/DepositsTable.vue';

@Component({
  components: {
    CustomDialog,
    DepositsTable
  }
})
export default class ResetPasswordDialog extends Vue {
  get lastFour() {
    return this.$store.getters['Account/getBankAccountLastFour'];
  }
}
